import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { HowItWorksCardProps } from "../../types/componentsConstructors";
import {
  CardWrapper,
  Container,
  ContentWrapper,
  Description,
  Divider,
  Title,
  ToggleIcon,
} from "./HowItWorksCardStyles";

const HowItWorksCard = ({ title, description }: HowItWorksCardProps) => {
  const [open, setOpen] = useState(false);

  return (
    <CardWrapper>
      <ContentWrapper>
        <Container onClick={() => setOpen(!open)}>
          <Title>{title}</Title>
          <ToggleIcon>{open ? "—" : "+"}</ToggleIcon>
        </Container>

        <AnimatePresence>
          {open && (
            <motion.div
              initial={{ height: 0, opacity: 0 }}
              animate={{ height: "auto", opacity: 1 }}
              exit={{ height: 0, opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <Description>{description}</Description>
            </motion.div>
          )}
        </AnimatePresence>

        <Divider />
      </ContentWrapper>
    </CardWrapper>
  );
};

export default HowItWorksCard;
